/* eslint-disable no-tabs */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
/* eslint-disable prefer-template */
/* eslint-disable */
import { CheckCircle, ModeEdit } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { classes, unitTypes } from '../../../Helpers';
// eslint-disable-next-line import/no-cycle
import { ListTable } from '../../ListTable';
import { BaseModal } from '../BaseModal';
import styles from './AuditItemsModal.module.scss';
import { Button } from '@/Components/ui/button';
import { Input } from '@/Components/ui/input';
import { modalActions } from '@/Actions';
import assetServices from '../../../Services/AssetServices/asset.services';
import auditServices from '../../../Services/audit-services';

const Legend = ({ items }) => {
	return (
		<div className='grid grid-cols-2 gap-1'>
			{items.map(({ label, subText, color }) => (
				<div
					key={label}
					className='flex items-start gap-2 bg-gray-50 shadow-sm rounded-lg p-2 min-h-[60px]'
				>
					<div
						className='w-3 h-3 mt-1 rounded-full flex-shrink-0'
						style={{
							backgroundColor: color,
						}}
					/>
					<div className='flex flex-col'>
						<p className='text-sm font-semibold text-gray-800'>
							{label}
						</p>
						{subText && (
							<p className='text-xs text-gray-500 leading-snug'>
								{subText}
							</p>
						)}
					</div>
				</div>
			))}
		</div>
	);
};

const LEGENDS_DATA = [
	{
		label: 'Rediscovered on other location',
		subText:
			'Qty of stock which was present on other location, but was scanned here. Current stock, Audited Stock, Moved Stock are incremented directly on scan',
		color: '#3B82F6', // blue-500
	},
	{
		label: 'Rediscovered on this location',
		subText:
			'Qty of stock which was present on this store, but was stocked out. Current stock, Audited Stock, Moved Stock are incremented directly on scan',
		color: '#F59E0B', // amber-500
	},
];

const COLMAP = {
	'Item Name': 'productName',
	Unit: 'unit',
	Category: 'category',
	'SKU Type': 'skuType',
	'Expected Stock': 'preAuditQty',
	'1st Audit Session Stock (B)': 'auditStockBackup',
	'2nd Audit Session Stock (C)': 'auditStock',
	'Final Audit Stock (D)': 'id',
	'Expired Stock (E)': 'expiredStock',
	Wastages: 'wastages',
	'Dispatched (F)': 'dispatched',
};

const SPECIAL_COLUMNS = [
	{
		title: 'Item Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'SKU Code',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'UY Variant ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Unit',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Item Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Item Sub Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'SKU Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Expected Stock (A)',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Last price',
		config: {
			type: 'DATA',
		},
	},
	{
		title: '1st Audit Session Stock (B)',
		config: {
			type: 'DATA',
		},
	},
	{
		title: '2nd Audit Session Stock (C)',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Final Audit Stock (D)',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Expired Stock (E)',
		config: {
			type: 'DATA',
		},
	},
	// {
	// 	title: 'Wastages',
	// 	config: {
	// 		type: 'DATA',
	// 	},
	// },
	{
		title: 'Dispatched (F)',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Rediscovered on other location (G)',
		config: {
			type: 'DATA',
			style: {
				backgroundColor: '#60A5FA', // blue-400
			},
		},
	},
	{
		title: 'Rediscovered on this location (H)',
		config: {
			type: 'DATA',
			style: {
				backgroundColor: '#FBBF24', // amber-400
			},
		},
	},
	// {
	// title: '+/- Manual Adjustment',
	// config: {
	// type: 'DATA',
	// },
	// },
	{
		// eslint-disable-next-line max-len
		// adjustment = (r.auditStock + r.adjustment + r.dispatchedStock + r.expiredStock - r.preAuditStock - r.movedStock - r.rediscoveredStock)
		title: 'Adjustment to current Stock [D+E+F-A-G-H]',
		config: {
			type: 'DATA',
		},
	},
];

const AuditItemsModal = (props) => {
	const { show, toggleAuditItemsModal, data, handleConfirm } = props;
	const {
		showInitiatedAuditItems,
		categories,
		skus,
		storeName,
		showGeneralDetails = false,
	} = data ?? {};
	// eslint-disable-next-line no-unused-vars
	const [loading, setLoading] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');
	const [isEdit, setIsEdit] = useState({});
	const [listData, setListData] = useState([]);
	const [assetsList, setAssetsList] = useState([]);
	const [selectedAsset, setSelectedAsset] = useState('all');
	const [assetsLoading, setAssetsLoading] = useState(false);
	const [itemsLoading, setItemsLoading] = useState(false);
	const [allItems, setAllItems] = useState([]);

	const calculatePostAdjustmentStock = (product) => {
		let postAdjustmentStock =
			product.auditStock +
			product.dispatchedStock +
			product?.expiredStock -
			(product.preAuditStock +
				product.movedStock +
				product.rediscoveredStock);
		if (product.adjustment && !isNaN(product.adjustment)) {
			postAdjustmentStock += Number(product.adjustment);
		}
		return postAdjustmentStock;
	};
	useEffect(() => {
		if (!data?.items || data?.items.length === 0) {
			return;
		}
		const sortedData = data?.items.sort((a, b) => {
			const postAdjustmentStockA = calculatePostAdjustmentStock(a);
			const postAdjustmentStockB = calculatePostAdjustmentStock(b);
			return postAdjustmentStockA - postAdjustmentStockB;
		});
		setListData(sortedData);
		setAllItems(sortedData);
	}, [data?.items]);

	// Fetch assets based on storeId when modal opens
	useEffect(() => {
		const fetchAssets = async () => {
			if (!data?.storeId || !show || data?.storeSubType !== 'DISPLAY')
				return;
			setAssetsLoading(true);
			try {
				const result = await assetServices.assetProductInventoryService(
					{
						req: {
							data: {
								storeId: data?.storeId,
							},
						},
					}
				);
				if (result?.status === 'Success' && result?.data?.assets) {
					setAssetsList(result.data.assets?.filter((asset) => asset.makeItemsNonTraceable === true));
				}
			} catch (error) {
				console.error('Error fetching assets:', error);
			} finally {
				setAssetsLoading(false);
			}
		};
		fetchAssets();
	}, [data?.storeId, show]);

	// Reset selectedAsset when modal closes
	useEffect(() => {
		if (!show) {
			setSelectedAsset('all');
			setAssetsList([]);
		}
	}, [show]);

	// Fetch audit items for a specific asset
	const handleAssetTabClick = useCallback(
		async (assetId) => {
			setSelectedAsset(assetId);
			if (assetId === 'all') {
				// Restore original items
				setListData(allItems);
				return;
			}
			try {
				setItemsLoading(true);
				const req = {
					data: {
						auditId: data?.auditId,
						assetId: assetId,
					},
				};
				const response = await auditServices?.fetchAuditItems(req);
				if (response?.statusCode === 200) {
					const sortedData = (response?.data?.report ?? []).sort(
						(a, b) => {
							const postAdjustmentStockA =
								calculatePostAdjustmentStock(a);
							const postAdjustmentStockB =
								calculatePostAdjustmentStock(b);
							return postAdjustmentStockA - postAdjustmentStockB;
						}
					);
					setListData(sortedData);
				}
			} catch (error) {
				console.error('Error fetching audit items for asset:', error);
			} finally {
				setItemsLoading(false);
			}
		},
		[data?.auditId, allItems]
	);
	const handleClose = () => {
		toggleAuditItemsModal(false, {});
	};

	const handleConfirmClick = () => {
		const adjustedData = listData
			?.filter((listEle) => {
				const prevItem = data?.items?.find((item) => {
					return item?.id === listEle?.id;
				});
				return listEle?.adjustment !== prevItem?.adjustment;
			})
			?.map((listEle) => {
				return {
					auditReportId: listEle?.id,
					adjustment: listEle?.adjustment
						? Number(listEle?.adjustment)
						: null,
				};
			});
		handleConfirm(data?.auditId, data?.storeId, adjustedData);
		// handleClose();
	};

	const renderBtns = () => {
		return (
			!data?.hideButtons && (
				<div className={styles.btns}>
					<Button
						className='flex-1'
						disabled={loading}
						onClick={handleClose}
						variant='secondary'
					>
						Close
					</Button>
					<Button
						className='flex-1 primary-btn'
						onClick={handleConfirmClick}
						disabled={data?.isDisabled}
					>
						{loading ? 'Loading...' : 'Adjust and Complete Audit'}
					</Button>
				</div>
			)
		);
	};

	const handleEditClick = (itemId) => {
		setIsEdit((prev) => {
			const temp = {
				...prev,
			};
			if (temp[itemId]) {
				temp[itemId] = false;
			} else {
				temp[itemId] = true;
			}
			return temp;
		});
	};

	const handleQtyChange = (e, id) => {
		setListData((prev) => {
			return prev?.map((ele) => {
				if (ele?.id === id) {
					return {
						...ele,
						adjustment: e?.target?.value,
					};
				}
				return ele;
			});
		});
	};

	const SPECIAL_ITEMS = {
		'Item Name': (id) => {
			const product = listData?.find((prod) => {
				return prod?.id === id;
			});
			return (
				<div>
					{product?.productName}
					{product?.variantName
						? ' (' + product?.variantName + ')'
						: ''}
				</div>
			);
		},
		Unit: (id) => {
			const product = listData?.find((prod) => {
				return prod?.id === id;
			});
			return product?.unit;
		},
		'Expected Stock (A)': (id) => {
			const product = listData?.find((prod) => {
				return prod?.id === id;
			});
			return product?.preAuditStock?.toLocaleString();
		},
		'SKU Type': (id) => {
			const product = listData?.find((prod) => {
				return prod?.id === id;
			});
			return product?.skuType ?? product?.product?.skuType ?? '-';
		},
		'Expired Stock (E)': (id) => {
			const product = listData?.find((prod) => {
				return prod?.id === id;
			});
			return product?.expiredStock;
		},
		'Item Category': (id) => {
			const product = listData?.find((prod) => {
				return prod?.id === id;
			});
			return (
				product?.categoryName ??
				product?.product?.ProductCategory?.productCategoryName ??
				'-'
			);
		},
		'Item Sub Category': (id) => {
			const product = listData?.find((prod) => {
				return prod?.id === id;
			});
			return product?.product?.ProductSubCategory?.name ?? '-';
		},
		'SKU Code': (id) => {
			const product = listData?.find((prod) => {
				return prod?.id === id;
			});
			return product?.variant?.clientVariantId ?? '-';
		},
		'UY Variant ID': (id) => {
			const product = listData?.find((prod) => {
				return prod?.id === id;
			});
			return product?.variantId ?? '-';
		},
		'1st Audit Session Stock (B)': (id) => {
			const product = listData?.find((prod) => {
				return prod?.id === id;
			});
			return product?.redo
				? product?.auditStockBackup?.toLocaleString()
				: product?.auditStock?.toLocaleString();
		},
		'2nd Audit Session Stock (C)': (id) => {
			const product = listData?.find((prod) => {
				return prod?.id === id;
			});
			return product?.redo ? product?.auditStock?.toLocaleString() : '-';
		},
		'Final Audit Stock (D)': (id) => {
			const product = listData?.find((prod) => {
				return prod?.id === id;
			});
			return product?.auditStock ?? product?.auditStockBackup ?? '-';
		},
		Wastages: (id) => {
			const product = listData?.find((prod) => {
				return prod?.id === id;
			});
			return product?.rejectedStock?.toLocaleString();
		},
		'Dispatched (F)': (id) => {
			const product = listData?.find((prod) => {
				return prod?.id === id;
			});
			return product?.dispatchedStock ?? '-';
		},
		'Rediscovered on other location (G)': (id) => {
			const product = listData?.find((prod) => {
				return prod?.id === id;
			});
			return product?.movedStock ?? '-';
		},
		'Rediscovered on this location (H)': (id) => {
			const product = listData?.find((prod) => {
				return prod?.id === id;
			});
			return product?.rediscoveredStock ?? '-';
		},
		'+/- Manual Adjustment': (id) => {
			const product = listData?.find((prod) => {
				return prod?.id === id;
			});
			if (!data?.isDisabled && isEdit[id]) {
				return (
					<div>
						<input
							type='number'
							placeholder='Change Order QTY'
							value={product?.adjustment ?? 0}
							onChange={(e) => {
								handleQtyChange(e, product?.id);
							}}
						/>
						<IconButton
							onClick={() => {
								handleEditClick(product?.id);
							}}
						>
							<CheckCircle />
						</IconButton>
					</div>
				);
			}
			if (product?.adjustment) {
				return (
					<span className={styles['order-qty']}>
						{/* <s className={styles.actual}>{product?.orderedQty}</s> */}
						<p>{product?.adjustment?.toLocaleString()}</p>
						{!data?.isDisabled && (
							<IconButton
								onClick={() => {
									handleEditClick(product?.id);
								}}
								className={styles['edit-btn']}
							>
								<ModeEdit />
							</IconButton>
						)}
					</span>
				);
			}
			return (
				<span className={styles['order-qty']}>
					<p>0</p>
					{!data?.isDisabled && (
						<IconButton
							onClick={() => {
								handleEditClick(product?.id);
							}}
							className={styles['edit-btn']}
						>
							<ModeEdit />
						</IconButton>
					)}
				</span>
			);
		},
		'Adjustment to current Stock [D+E+F-A-G-H]': (id) => {
			const product = listData?.find((prod) => {
				return prod?.id === id;
			});
			let postAdjustmentStock =
				product?.auditStock +
				product?.dispatchedStock +
				product?.expiredStock -
				(product?.preAuditStock +
					product?.movedStock +
					product?.rediscoveredStock);
			// eslint-disable-next-line no-restricted-globals
			if (product?.adjustment && !isNaN(product?.adjustment)) {
				postAdjustmentStock += Number(product?.adjustment);
			}
			return postAdjustmentStock?.toLocaleString();
		},
		'Last price': (id) => {
			const product = listData?.find((prod) => {
				return prod?.id === id;
			});
			return `₹${product?.lastPrice ?? '-'}/${
				unitTypes[product?.unit]?.postConversionUnit ?? '-'
			}`;
		},
	};

	const DATA = useMemo(() => {
		return listData?.filter((ele) => {
			return (
				ele?.productName
					?.toLowerCase()
					?.indexOf(searchQuery?.toLowerCase()?.trim()) !== -1
			);
		});
	}, [listData, searchQuery]);

	const getRowColor = (ele) => {
		const product = listData?.find((prod) => {
			return prod?.id === ele?.id;
		});
		let postAdjustmentStock =
			product?.auditStock +
			product?.dispatchedStock +
			product?.expiredStock -
			(product?.preAuditStock +
				product?.movedStock +
				product?.rediscoveredStock);
		// eslint-disable-next-line no-restricted-globals
		if (product?.adjustment && !isNaN(product?.adjustment)) {
			postAdjustmentStock += Number(product?.adjustment);
		}
		const value = parseFloat(
			String(postAdjustmentStock || '').replace(/,/g, '')
		);
		if (value > 0) {
			return styles.positive;
		}
		if (value < 0) {
			return styles.negative;
		}
		return -1;
	};
	// const handleExport = () => {
	// const headers = SPECIAL_COLUMNS?.map((ele) => {
	// return ele?.title;
	// })?.filter((ele) => {
	// return ele !== 'Final Indent' && ele !== 'Recipe Exists';
	// });
	// headers?.splice(1, 0, ...['Variant Name', 'Sku Type']);
	// const totalValues = [];
	// const exportData = [
	// ...listData?.PRODUCT,
	// ...listData?.INTERMEDIATE,
	// ...listData?.INGREDIENT,
	// ];
	// exportData?.forEach((product) => {
	// const delta =
	// product?.updatedQty !== product?.orderedQty
	// ? product?.updatedQty - product?.orderedQty
	// : 0;
	// totalValues?.push([
	// product?.productName ?? '-',
	// product?.variantName ?? '-',
	// product?.productType ?? '-',
	// product?.unit ?? '-',
	// product?.stock ?? '-',
	// product?.currentDayStockIn ?? '-',
	// product?.currentDayCount ?? '-',
	// product?.prePlanStock ?? '-',
	// product?.threshold ?? '-',
	// product?.orderedQty ?? '-',
	// '-',
	// delta ?? '-',
	// product?.calculatedQty ?? '-',
	// product?.batchSize ?? '-',
	// product?.finalProduction ?? '-',
	// ]);
	// });
	// handleExcelDownload(
	// headers,
	// totalValues,
	// `Production Plan for ${data?.date}`
	// );
	// };
	const getColoumnsBasedOnRedo = () => {
		if (data?.items && data?.items.length > 0) {
			const isRedo = data?.items?.every((ele) => {
				return (
					ele?.redo === null ||
					ele?.redo === undefined ||
					ele?.redo === false
				);
			});
			if (isRedo) {
				return SPECIAL_COLUMNS.filter((ele) => {
					return (
						ele?.title !== '1st Audit Session Stock (B)' &&
						ele?.title !== '2nd Audit Session Stock (C)'
					);
				});
			}
		}
		return SPECIAL_COLUMNS;
	};

	return (
		<BaseModal
			heading={`Audit items (id: ${data?.auditId})`}
			open={show}
			handleClose={handleClose}
			customStyles={{
				width: '95%',
				height: '90vh',
				// top: '25%',
			}}
			renderBtns={renderBtns}
			// handleConfirm={handleConfirm}
		>
			<Legend items={LEGENDS_DATA} />
			<div className={`${styles.root}`}>
				{showGeneralDetails && (
					<div className={styles.general_details}>
						<div className={styles.labelled_value}>
							<label>Store Name</label>
							<div className={styles.values}>
								<p className={styles.value}>{storeName}</p>
							</div>
						</div>
						<div className={styles.labelled_value}>
							<label>Categories</label>
							<div className={styles.values}>
								{categories?.map((ele) => {
									return (
										<div className={styles.value}>
											{ele?.productCategoryName}
										</div>
									);
								})}
							</div>
						</div>
						<div className={styles.labelled_value}>
							<label>SKU Types</label>
							<div className={styles.values}>
								{skus?.map((ele) => {
									return (
										<div className={styles.value}>
											{ele}
										</div>
									);
								})}
							</div>
						</div>
					</div>
				)}
				{/* Asset Tabs */}
				{assetsList?.length > 0 && (
					<div className={styles.assetTabs}>
						<div
							className={`${styles.assetTab} ${
								selectedAsset === 'all' ? styles.activeTab : ''
							}`}
							onClick={() => handleAssetTabClick('all')}
						>
							All
						</div>
						{assetsList.map((asset) => (
							<div
								key={asset.id}
								className={`${styles.assetTab} ${
									selectedAsset === asset.id
										? styles.activeTab
										: ''
								}`}
								onClick={() => handleAssetTabClick(asset.id)}
							>
								{asset.name || `Asset #${asset.id}`}
							</div>
						))}
					</div>
				)}
				{(assetsLoading || itemsLoading) && (
					<div className='text-center text-sm text-gray-500 py-2'>
						{assetsLoading
							? 'Loading assets...'
							: 'Loading items...'}
					</div>
				)}
				<div className={styles.filters}>
					<Input
						className='focus:outline-none'
						value={searchQuery}
						onChange={(e) => {
							setSearchQuery(e.target.value);
						}}
						placeholder='Search SKU'
					/>
				</div>
				<div
					className={classes(
						styles.list,
						data?.hideButtons ? styles.fullHeight : ''
					)}
				>
					<ListTable
						colMap={COLMAP}
						columns={[]}
						data={DATA?.map((ele) => {
							const rowStyles = getRowColor(ele);
							return {
								...ele,
								rowStyles,
							};
						})}
						actions={[...getColoumnsBasedOnRedo()]?.filter(
							(ele) => {
								if (showInitiatedAuditItems) {
									return (
										ele?.title !== 'Expected Stock (A)' &&
										ele?.title !== 'Audit Stock (B)' &&
										ele?.title !== 'Wastages' &&
										ele?.title !== 'Dispatched (F)' &&
										ele?.title !==
											'Adjustment to current Stock [D+E+F-A-G-H]' &&
										ele?.title !== 'Expired Stock (E)' &&
										ele?.title !==
											'Rediscovered on other location (G)' &&
										ele?.title !==
											'Rediscovered on this location (H)' &&
										ele?.title !== 'Last price'
									);
								}
								return true;
							}
						)}
						special={SPECIAL_ITEMS}
						fixedHeaderTop='0'
					/>
				</div>
			</div>
		</BaseModal>
	);
};

const mapStateToProps = (state) => {
	const { show, data } = state.modal.auditItemsModal;
	return {
		show,
		data,
	};
};

const mapDispatchToProps = {
	toggleAuditItemsModal: modalActions.toggleAuditItemsModal,
};
export default connect(mapStateToProps, mapDispatchToProps)(AuditItemsModal);
